var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconEye = function SvgIconEye(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 5.657S2.829 0 7.778 0c4.951 0 7.779 5.657 7.779 5.657s-2.828 5.657-7.779 5.657C2.829 11.314 0 5.657 0 5.657z",
    transform: "translate(-954.000000, -639.000000) translate(943.000000, 626.000000) translate(12.000000, 14.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.778 3.535c1.171 0 2.122.95 2.122 2.122 0 1.171-.95 2.122-2.122 2.122-1.17 0-2.122-.95-2.122-2.122 0-1.171.951-2.122 2.122-2.122z",
    transform: "translate(-954.000000, -639.000000) translate(943.000000, 626.000000) translate(12.000000, 14.000000)"
  })))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconEye);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-eye.1abf92365dbe3e6a143728b69bafaf04.svg";